@if (isLoading) {
    <loading [isLoading]="isLoading" [success]="true"></loading>
} @else {
    <div class="flex flex-col text-sm gap-2">
        @if (error) {
            <div class="p-1 rounded border border-red-600 text-red-600 text-xs sm:text-sm">
                {{ errorMessage }}
            </div>
        } @else {
            @if (paymentMethods.length == 0) {
                <div class="text-slate-400 text-center italic text:xs sm:text-sm">
                    You have no active payment methods.
                </div>
            } @else {
                @for (paymentMethod of paymentMethods ; track paymentMethod.id) {
                    <user-payment-method [paymentMethod]="paymentMethod"></user-payment-method>
                }
            }
            <div class="flex flex-row justify-end">
                <new-payment-method></new-payment-method>
            </div>
            <div class="text-right text-xs text-slate-400">
                You will be redirected to our payment processor <a href="https://www.stripe.com" class="text-ponder-link hover:text-ponder-linkhover">Stripe</a>
            </div>
        }
    </div>
}